export default __webpack_public_path__ + "static/media/ReturnButton.9cf9f4b2.svg";